<script setup lang="ts">
import AccordionContent, {
  type AccordionContentProps
} from "primevue/accordioncontent";

export interface TaiAccordionContentProps extends AccordionContentProps {}

const props = defineProps<TaiAccordionContentProps>();
</script>

<template>
  <AccordionContent v-bind="{ ...$props, ...$attrs }">
    <slot></slot>
  </AccordionContent>
</template>
